export { default } from './ViewCompositionRecordings';
